export function Header() {
  const el = document.createElement('header')
  el.className = 'site-header'
  el.innerHTML = `
    <div class="container header-inner">
      <a href="#/" class="wordmark">nameo</a>
    </div>
  `
  return el
}
